<template>
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-10">
            <h2 class="mb-3 font-weight-bold">{{ $t("navigations.study status master settings") }}</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-md-3">
            <div class="ibox">
                <div class="ibox-title style_2 d-flex justify-content-between align-self-center">
                    <h5 class="my-0 ">{{ $t("navigations.status types") }}</h5>
                    <div class="d-flex justify-content-end mb-2">
                        <div class="position-relative align-self-center cursor-pointer" aria-label="Create status"
                            tabindex="0" @click="openStatusTypeModal()">
                            <img width="17" height="17" src="../../assets/img/create.png" alt="Create status" />
                            <div class="tool-tip">{{ $t("navigations.create status type") }}</div>

                        </div>
                    </div>
                </div>
                <div class="ibox-content scroll_horizontal p-2">
                    <div class="template-body">

                        <div class="panel-group" id="accordion">
                            <div class="panel panel-default" v-for="(item, index) in statusPanels" :key="index">
                                <div class="panel-heading d-flex justify-content-between py-1 cursor-pointer"
                                 :class="{ 'selected-panel': selectedPanel === item.key }"
                                    @click="selectPanel(item.key)">
                                    <h5 class="panel-title">{{ item.label }}</h5>
                                    <div class="expand-delete-block cursor-pointer align-self-center position-relative px-2"
                                        tabindex="0" aria-label="Expand options"
                                        @click.prevent="showSideModal[index] = !showSideModal[index]"
                                        v-on:clickout="showSideModal[index] = false">
                                        <i class="fa fa-ellipsis-v"></i>

                                        <div class="side-popup position-absolute py-2" v-if="showSideModal[index]">
                                            <div class="d-flex px-3" @click.prevent.stop="deleteStatusType(item)">
                                                <i class="fa fa-trash icon-color align-self-center pr-2"></i>
                                                <span>Delete</span>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Grid -->
        <div class="col-md-9">
            <div v-if="selectedPanel" class="ibox-body">
                <div class="ibox-title style_2 d-flex justify-content-between">
                    <h5 class="mt-1">{{ getPanelLabel(selectedPanel) }}</h5>
                    <div class="d-flex">
                        <div class="position-relative align-self-center cursor-pointer" aria-label="Create status"
                            tabindex="0" @click="openCreateModal">
                            <img width="17" height="17" src="../../assets/img/create.png" alt="Create status" />
                            <div class="tool-tip">{{ $t("navigations.create status") }}</div>
                        </div>
                    </div>
                </div>

                <div class="ibox-content">
                    <div v-if="tableData[selectedPanel] && tableData[selectedPanel].length === 0" class="text-center">
                        No records found.
                    </div>

                    <div v-else class="table-responsive">
                        <table class="table table-striped table-bordered dataTables">
                            <thead>
                                <tr>
                                    <th class="text-center" @click="SortSelected('Status')" :class="{
                                        sortAsc: SortProperty === 'Status' && SortOrder,
                                        sortDesc: SortProperty === 'Status' && !SortOrder,
                                    }">
                                        <div class="d-flex flex-row justify-content-between text-center">{{
                                            $t("navigations.name") }}
                                            <span>
                                                <i class="fa fa-long-arrow-up"></i>
                                                <i class="fa fa-long-arrow-down"></i>
                                            </span>
                                        </div>
                                    </th>
                                    <th class="text-center">{{ $t("navigations.description") }}</th>
                                    <th class="text-center">{{ $t("navigations.color code") }}</th>
                                    <th class="text-center">{{ $t("navigations.active") }}</th>
                                    <th class="text-center">{{ $t("navigations.edit") }}</th>
                                    <th class="text-center">{{ $t("navigations.delete") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, index) in tableData" :key="index">

                                    <td>{{ row.status }}</td>
                                    <td>{{ row.description }}</td>
                                    <td class="text-center">
                                        <span :style="{
                                            backgroundColor: row.colorCode,
                                            padding: '3px 10px',
                                            borderRadius: '4px',
                                            color: '#000'
                                        }">
                                            {{ row.colorCode }}
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <input type="checkbox" :checked="row.active" disabled />
                                    </td>
                                    <td class="text-center">
                                        <i class="fa fa-edit edit-delete cursor-pointer" @click="editRow(row)" />
                                    </td>
                                    <td class="text-center">
                                        <i class="fa fa-trash edit-delete cursor-pointer" @click="deleteRow(row)" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="col-md-12 d-flex justify-content-md-end px-0">
                            <VPagination v-model="currentPage" :pages="totalPage" :range-size="1" active-color="#ededed"
                                @update:modelValue="loadPage" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- model create status -->
    <customModal :containersm="true" v-if="showCreateStatusModal" @closeModal="closeModal">
        <template #title>
            {{ $t("navigations.create status") }}
        </template>

        <template #body>
            <div class="form-group">
                <label>{{ $t("navigations.status name") }}<sup><i class="fa fa-asterisk required"></i></sup></label>
                <input v-model="newStatus.status" class="form-control form-control-sm" type="text"
                    :class="{ 'is-invalid': statusError }" @input="clearError" />
                <div class="invalid-feedback" v-if="statusError">
                    {{ statusError }}
                </div>
            </div>


            <div class="form-group">
                <label> {{ $t("navigations.status type") }}</label>
                <input v-model="newStatus.statusType" class="form-control form-control-sm" type="text" disabled />
            </div>


            <div class="form-group">
                <label>{{ $t("navigations.description") }}</label>
                <textarea v-model="newStatus.description" class="form-control form-control-sm" rows="2" />
            </div>

            <!-- <div class="form-group">
                <label>{{ $t("navigations.color code") }}</label>
                <div class="d-flex align-items-center">
                    <input v-model="newStatus.colorCode" class="form-control form-control-sm mr-2" type="text"
                        placeholder="#FF0000" />
                    <input v-model="newStatus.colorCode"  type="color"
                        style="width: 40px; padding: 0;" />
                </div>
            </div> -->
            <div class="form-group">
                <label>{{ $t("navigations.color code") }}</label>
                <div class="d-flex align-items-center">
                    <!-- Hex code input -->
                    <input v-model="newStatus.colorCode" class="form-control form-control-sm mr-2" type="text"
                        placeholder="#FF0000" />

                    <!-- Color box with tooltip -->
                    <input v-model="newStatus.colorCode" type="color" title="Pick a color"
                        style="width: 40px; height: 28px;padding: 0px;cursor: pointer;border: 0px;" />
                </div>
            </div>

            <div class="form-group">
                <label>
                    <input type="checkbox" v-model="newStatus.active" class="mr-1" /> {{ $t("navigations.active") }}
                </label>
            </div>

            <div class="text-right">
                <!-- <button class="btn btn-sm btn-secondary mr-2" @click="showCreateStatusModal = false">Cancel</button> -->
                <button class="save_btn py-1 px-4 position-relative" @click="submitNewStatus">
                    {{ isEditMode ? 'Update' : 'Create' }}
                </button>
            </div>
        </template>
    </customModal>

    <!-- model end -->
    <!-- model create status type -->
    <customModal :containersm="true" v-if="showCreateStatusTypeModal" @closeModal="closeStatusTypeModal">
        <template #title>
            {{ $t("navigations.create status type") }}
        </template>

        <template #body>
            <div class="form-group">
                <label>{{ $t("navigations.status label") }}<sup><i class="fa fa-asterisk required"></i></sup></label>
                <input v-model="newStatusType.name" class="form-control form-control-sm" type="text"
                    :class="{ 'is-invalid': statusLabelError }" @input="clearStatusLabelError" />
                <div class="invalid-feedback" v-if="statusLabelError">
                    {{ statusLabelError }}
                </div>
            </div>
            <div class="form-group">
                <label>{{ $t("navigations.status type") }}<sup><i class="fa fa-asterisk required"></i></sup></label>
                <input v-model="newStatusType.type" class="form-control form-control-sm" type="text"
                    :class="{ 'is-invalid': statusTypeError }" @input="clearStatusTypeError" />
                <div class="invalid-feedback" v-if="statusTypeError">
                    {{ statusTypeError }}
                </div>
            </div>

            <div class="form-group">
                <label>{{ $t("navigations.description") }}</label>
                <textarea v-model="newStatusType.description" class="form-control form-control-sm" rows="2" />
            </div>

            <div class="form-group">
                <label>
                    <input type="checkbox" v-model="newStatusType.active" class="mr-1" />
                    {{ $t("navigations.active") }}
                </label>
            </div>

            <div class="text-right">
                <button class="save_btn py-1 px-4 position-relative" @click="submitNewStatusType()">
                    {{ isEditStatusTypeMode ? 'Update' : 'Create' }}
                </button>
            </div>
        </template>
    </customModal>


</template>

<script src="./StudyStatusMaster.js"></script>
<style scoped>
.scroll_horizontal {
    height: 550px;
    overflow: auto;
}

.cursor-pointer {
    cursor: pointer;
}

.side-popup {
    text-align: left;
    left: -166px !important;
    width: 170px !important;
    border-radius: 5px;
    border: 1px solid #e7eaec;
    background-color: rgba(255, 255, 255, 1);
    -moz-box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
    -webkit-box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
    box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5) !important;
    z-index: 200;
}

.side-popup>*:is(:hover, :focus) {
    background-color: #e4eaf9;
}

.expand-delete-block:is(:hover, :focus) {
    border-radius: 50%;
    background-color: #dddddd;
}

.tooltip-icon {
    position: relative;
    margin-left: 6px;
    cursor: pointer;
}

.eyedropper-wrapper {
  position: relative;
  display: inline-block;
  margin-left: 12px;
}

.tool-tip {
  position: absolute;
  bottom: 120%; 
  left: 100%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 4px 8px;
  font-size: 12px;
  white-space: nowrap;
  border-radius: 4px;
  opacity: 0;
  pointer-events: none;
  z-index: 10;
  transition: opacity 0.2s ease;
}

.eyedropper-wrapper:hover .tool-tip {
  opacity: 1;
}
.selected-panel {
  background-color: #e6f7ff;
  font-weight: 500;
}

</style>